import { render, staticRenderFns } from "./multiselect.vue?vue&type=template&id=f401128c&scoped=true&"
import script from "./multiselect.vue?vue&type=script&lang=js&"
export * from "./multiselect.vue?vue&type=script&lang=js&"
import style0 from "./multiselect.vue?vue&type=style&index=0&id=f401128c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f401128c",
  null
  
)

export default component.exports